module.exports = __webpack_public_path__ + "img/hs.a7a3e406.png";